<template>
  <v-snackbar
    v-model="isShow"
    :bottom="option.y === 'bottom'"
    :left="option.x === 'left'"
    :multi-line="option.mode === 'multi-line'"
    :right="option.x === 'right'"
    :timeout="option.timeout"
    :top="option.y === 'top'"
    :vertical="option.mode === 'vertical'"
  >
    {{ text }}
    <v-btn color="white" flat @click="isShow = false">Close</v-btn>
  </v-snackbar>
</template>
<script>
export default {
  name: 'snackbar',
  data () {
    return {
      text: '',
      option: {},
      isShow: false
    }
  },
  methods: {
    show (message, option) {
      this.text = message
      this.option = Object.assign({
        y: 'bottom',
        timeout: 4000
      }, this.option)
      this.isShow = true
    }
  }
}
</script>
